/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepairOrder
 */
export interface RepairOrder {
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    roNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    wipId: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    wipNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    vehicle: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    requestType: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    estimator?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOrder
     */
    onRo?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    vin: string | null;
    /**
     * 
     * @type {number}
     * @memberof RepairOrder
     */
    roTotal: number | null;
    /**
     * 
     * @type {Date}
     * @memberof RepairOrder
     */
    requestedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RepairOrder
     */
    requestSubmitted?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RepairOrder
     */
    requestScheduled?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RepairOrder
     */
    requestCompleted?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOrder
     */
    invoiced?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    systemStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RepairOrder
     */
    substatus?: string | null;
}

/**
 * Check if a given object implements the RepairOrder interface.
 */
export function instanceOfRepairOrder(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "roNumber" in value;
    isInstance = isInstance && "wipId" in value;
    isInstance = isInstance && "wipNumber" in value;
    isInstance = isInstance && "vehicle" in value;
    isInstance = isInstance && "requestType" in value;
    isInstance = isInstance && "vin" in value;
    isInstance = isInstance && "roTotal" in value;

    return isInstance;
}

export function RepairOrderFromJSON(json: any): RepairOrder {
    return RepairOrderFromJSONTyped(json, false);
}

export function RepairOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepairOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'roNumber': json['roNumber'],
        'wipId': json['wipId'],
        'wipNumber': json['wipNumber'],
        'vehicle': json['vehicle'],
        'requestType': json['requestType'],
        'estimator': !exists(json, 'estimator') ? undefined : json['estimator'],
        'onRo': !exists(json, 'onRo') ? undefined : json['onRo'],
        'vin': json['vin'],
        'roTotal': json['roTotal'],
        'requestedDate': !exists(json, 'requestedDate') ? undefined : (json['requestedDate'] === null ? null : new Date(json['requestedDate'])),
        'requestSubmitted': !exists(json, 'requestSubmitted') ? undefined : (json['requestSubmitted'] === null ? null : new Date(json['requestSubmitted'])),
        'requestScheduled': !exists(json, 'requestScheduled') ? undefined : (json['requestScheduled'] === null ? null : new Date(json['requestScheduled'])),
        'requestCompleted': !exists(json, 'requestCompleted') ? undefined : (json['requestCompleted'] === null ? null : new Date(json['requestCompleted'])),
        'invoiced': !exists(json, 'invoiced') ? undefined : json['invoiced'],
        'systemStatus': !exists(json, 'systemStatus') ? undefined : json['systemStatus'],
        'substatus': !exists(json, 'substatus') ? undefined : json['substatus'],
    };
}

export function RepairOrderToJSON(value?: RepairOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'roNumber': value.roNumber,
        'wipId': value.wipId,
        'wipNumber': value.wipNumber,
        'vehicle': value.vehicle,
        'requestType': value.requestType,
        'estimator': value.estimator,
        'onRo': value.onRo,
        'vin': value.vin,
        'roTotal': value.roTotal,
        'requestedDate': value.requestedDate === undefined ? undefined : (value.requestedDate === null ? null : value.requestedDate.toISOString()),
        'requestSubmitted': value.requestSubmitted === undefined ? undefined : (value.requestSubmitted === null ? null : value.requestSubmitted.toISOString()),
        'requestScheduled': value.requestScheduled === undefined ? undefined : (value.requestScheduled === null ? null : value.requestScheduled.toISOString()),
        'requestCompleted': value.requestCompleted === undefined ? undefined : (value.requestCompleted === null ? null : value.requestCompleted.toISOString()),
        'invoiced': value.invoiced,
        'systemStatus': value.systemStatus,
        'substatus': value.substatus,
    };
}

